<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Users</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-user @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="row">
          <!-- Role -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedRole"
              placeholder="Filter role"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleRoleChange"
              :filterOption="false"
              :defaultValue="undefined"
            >
              <a-select-option :value="undefined">All Roles</a-select-option>
              <a-select-option value="admin">Admin</a-select-option>
              <a-select-option value="supervisor">Supervisor</a-select-option>
            </a-select>
          </div>
          <!-- Status -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedStatus"
              placeholder="Filter status"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleStatusChange"
              :filterOption="false"
              :defaultValue="undefined"
            >
              <a-select-option :value="undefined">All Status</a-select-option>
              <a-select-option :value="1">Active</a-select-option>
              <a-select-option :value="0">Inactive</a-select-option>
            </a-select>
          </div>
          <div class="col-md-4 offset-md-2 col-12 text-right mb-2">
            <a-input-search
              placeholder="Search Users"
              size="large"
              style="width: 100%"
              @search="searchUsers"
              @change="searchUsers"
              v-model="searchTerm"
            />
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <users-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import UsersTable from '@/components/user/Table/index'
import AddUser from '@/components/user/Forms/Add/index'

export default {
  components: {
    UsersTable,
    AddUser,
  },
  mounted: function() {
    this.getUsers()
  },
  created() {
    this.searchUsers = debounce(this.searchUsers, 500)
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      selectedRole: undefined,
      selectedStatus: undefined,
      data: [],
      meta: {},
      current: 1,
      pageSize: 10,
      searchTerm: undefined,
    }
  },
  methods: {
    getUsers: function() {
      this.loading = true
      this.$http.get('/api/user', {
        params: {
          limit: this.pageSize,
          page: this.current,
          role: this.selectedRole,
          status: this.selectedStatus,
          search: this.searchTerm,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleRoleChange() {
      this.getUsers()
    },
    handleStatusChange() {
      this.getUsers()
    },
    searchUsers: function(e) {
      if (e.target.value === '') this.searchTerm = undefined
      this.getUsers()
    },
    handleCreated: function() {
      this.getUsers()
    },
    handleUpdateTable: function() {
      this.getUsers()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getUsers()
    },
    onChange(current) {
      this.current = current
      this.getUsers()
    },
  },
}
</script>
